/**
 * 时间格式化
 * @export
 * @param {*} val
 * @param {*} type 日期类型，data：年月日，datatime：年月日时分秒
 * @returns
 */
 export function formatDateTime (val, type) {
  var date = '';
  if (val) {
    date = new Date(val);
  } else {
    date = new Date();
  };
  var Y = date.getFullYear();
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return type === 'data' ? Y + '-' + M + '-' + D : Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
};

/**
 * 设置cookie
   obj: 存储cookie的obj对象
   timeType：时间类型，是按照分钟、小时还是天数
   timeNum：cookie有效期多少分钟、小时还是天
 */
export function setCookie(obj, timeType, timeNum) {
  let dateTime = '';
  if (timeType === 'min') {
    let dayTime = new Date(new Date().getTime() + timeNum * 60 * 1000).toUTCString();
    dateTime = dayTime;
  } else if (timeType === 'hours') {
    let hoursTime = new Date(new Date().getTime() + timeNum * 60 * 60 * 1000).toUTCString();
    dateTime = hoursTime;
  } else if (timeType === 'day') {
    let dayTime = new Date(new Date().getTime() + timeNum * 24 * 60 * 60 * 1000).toUTCString();
    dateTime = dayTime;
  }  
  for (let key in obj) {
    document.cookie = key + '=' + obj[key] + '; expires=' + dateTime;
  }
};

/**
 * 读取cookie
 */
 export function getCookie(key) {
  let resCookie = document.cookie.match(new RegExp("(^|\\s)" + key + "=([^;]+)(;|$)"));
  return resCookie&&resCookie.length ? document.cookie.match(new RegExp("(^|\\s)" + key + "=([^;]+)(;|$)"))[2] : '';
};

/**
 * 删除cookie
 */
 export function removeCookie(key) {
  setCookie({
    [key]: ""
  }, -1);
};

/**
 * 过滤参数
 * @export
 * @param {*} params
 * @returns
 */
export function paramsFilter(params) {
  const obj = {};
  for (var key in params) {
    if (params[key] || params[key] === null) {
      obj[key] = params[key];
    } else if (params[key] === 0) {
      obj[key] = params[key];
    };
  };
  return obj;
};